import { Injectable } from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { Platform } from 'ionic-angular';
import { Observable } from 'rxjs';

@Injectable()
export class ImageProvider {

  constructor(private camera: Camera, private platform: Platform) {
  }

  public uriToBase64(imageData): string {
    let base64Image = 'data:image/jpeg;base64,' + imageData;
    return base64Image;
  }

  public getImageFromCamera(): Observable<string> {
    return this.getImage(this.camera.PictureSourceType.CAMERA);
  }

  public getImageFromLibrary(): Observable<string> {
    return this.getImage(this.camera.PictureSourceType.PHOTOLIBRARY);
  }

  private getImage(sourceType: number) {
    return Observable.create(observer => {
      if (!this.platform.is('cordova')) {
        observer.complete();
        return;
      }

      const options: CameraOptions = {
        destinationType: this.camera.DestinationType.DATA_URL,
        encodingType: this.camera.EncodingType.JPEG,
        mediaType: this.camera.MediaType.PICTURE,
        sourceType: sourceType,

        correctOrientation: true,
        //saveToPhotoAlbum: true,

        quality: 75,
        targetWidth: 1280,
        targetHeight: 720,
      }

      this.camera.getPicture(options).then(
        (imageData) => {
          observer.next(imageData);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/image.ts